import { ROUTES } from '@/constants/routes';
import { DialogContent, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { GeneralAlert } from '../Alerts/GeneralAlert';

export const NoPhoneBody = () => {
  const { t } = useTranslation();
  return (
    <DialogContent sx={{ paddingBlockEnd: 3 }}>
      <Stack gap={2}>
        <Typography color="text.secondary" variant="body1">
          {t('phone_sign_document_description')}
        </Typography>
        <GeneralAlert
          severity="error"
          title={t('no_phone_number_added')}
          body={t(
            'in_order_to_sign_with_a_one_time_password_you_need_to_add_a_phone_number_to_your_profile'
          )}
          link={ROUTES.profile}
          action={`${t('add_phone_number')} ↗`}
          alertTextColor="error.160p"
        />
      </Stack>
    </DialogContent>
  );
};
